// extracted by mini-css-extract-plugin
module.exports = {"account":"styles_account__3iP_A","left":"styles_left__3bKBU","logout":"styles_logout__Dspa6","role":"styles_role__1n5dW"};